import useJobsPageStore from "../pages/Jobs/hooks/useJobsPageStore"

import { Column, Row } from "./Layout"
import TextLabel from "./typography/TextLabel"
import { AllRegions } from "../types"


export default function RegionSelector() {
    const { selectedRegion, setSelectedRegion } = useJobsPageStore()

    return (<Row className="custom-region-selector" justifyContent="space-between" data-selected-region={Boolean(selectedRegion) ? selectedRegion?.toLowerCase() : "all"}>
        {AllRegions.map((regionDetails, i) => {

            const { regionName, regionKey, imageUrl, icon } = regionDetails

            const activeClassName = selectedRegion == regionKey ? "active" : ""

            return (
                <Column
                    key={`${i}_${regionDetails.regionKey}`}
                    className={`custom-region-selector-item scale-on-hover-lg underline-on-hover ${activeClassName}`}
                    style={{ cursor: "pointer" }}
                    alignItems={"center"}
                    onClick={() => {
                        console.log(regionKey)
                        setSelectedRegion(regionKey)
                    }}
                >
                    {(imageUrl != undefined) ? <img src={imageUrl} style={{ maxHeight: "24px" }} /> : icon}
                    <TextLabel>{regionName}</TextLabel>
                </Column>
            )
        })}
    </Row>)
}